import React, { useState } from "react";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import {
  HomeOutlined,
  Inventory2Outlined,
  AddPhotoAlternateOutlined,
  NewspaperOutlined,
  SettingsApplicationsOutlined,
  Factory,
  Public,
  Calculate,
  QuestionAnswerOutlined,
  AddBusiness,
  Warehouse,
  AppRegistrationOutlined,
  ListOutlined,
  PersonOutline,
  UploadFile,
  OndemandVideoOutlined
} from "@mui/icons-material";
import BannerPubPgi from "../BannerPubPgi";
import BloqueTxtPgi from "../BloqueTxtPgi";

const NavBarPgi = () => {
  const [open, setOpen] = useState(false);
  const handleClick = (e) => {
    setOpen(!open);
  };

  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name;

  return (
    <div id="navBarPgi" className={open ? `abierto` : `cerrado`}>
      <button className="menuPgibutton" onClick={handleClick}>
        <MenuOpenIcon />
      </button>
      <nav id="sideBarMenuPgi" open={open}>
        <ul>
        <li className="itemContent">
            <a id="edit-pendientes" href="/pgi">
              <ListOutlined /> <span>Pendientes</span>
            </a>
            {!open ? <div className="tooltips">Pendientes</div> : ""}
          </li>
          <hr />
          <li className="itemContent">
            <a id="edit-home" href="/pgi/edit-home">
              {" "}
              <HomeOutlined /> <span>Home</span>
            </a>
            {!open ? <div className="tooltips">Home</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-products" href="/pgi/edit-productos">
              <Inventory2Outlined /> <span>Productos</span>
            </a>
            {!open ? <div className="tooltips">Productos</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-news" href="/pgi/edit-news">
              <NewspaperOutlined /> <span>Blog</span>
            </a>
            {!open ? <div className="tooltips">Blog</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-faqs" href="/pgi/edit-preguntas-frecuentes">
              <QuestionAnswerOutlined /> <span>FAQs</span>
            </a>
            {!open ? <div className="tooltips">Preguntas frecuentes</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-empresa" href="/pgi/edit-empresa">
              <Factory /> <span>Empresa</span>
            </a>
            {!open ? <div className="tooltips">Empresa</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-intheworld" href="/pgi/edit-intheworld">
              <Public /> <span>En el mundo</span>
            </a>
            {!open ? <div className="tooltips">En el mundo</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-calculadora" href="/pgi/edit-calculadora">
              <Calculate /> <span>Calculadora</span>
            </a>
            {!open ? <div className="tooltips">Calculadora</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-corralones" href="/pgi/edit-corralones">
              <Warehouse /> <span>Corralones</span>
            </a>
            {!open ? <div className="tooltips">Corralones</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-footer" href="/pgi/edit-footer">
              <AppRegistrationOutlined /> <span>Footer</span>
            </a>
            {!open ? <div className="tooltips">Footer</div> : ""}
          </li>
          <hr />
          <li className="itemContent">
            <a id="edit-galeria" href="/pgi/galeria">
              <AddPhotoAlternateOutlined /> <span>Galería</span>
            </a>
            {!open ? <div className="tooltips">Galería</div> : ""}
          </li>
          <li className="itemContent">
            <BannerPubPgi open={open} />
          </li>
          <li className="itemContent">
            <BloqueTxtPgi open={open} />
          </li>
          <hr />
          <li className="itemContent">
            <a id="edit-clientes" href="/pgi/seccion-clientes">
              <UploadFile /> <span>Seccion Clientes</span>
            </a>
            {!open ? <div className="tooltips">Seccion Clientes</div> : ""}
          </li>
          <li className="itemContent">
            <a id="edit-config" href="/pgi/configuracion">
              <SettingsApplicationsOutlined /> <span>Configuración</span>
            </a>
            {!open ? <div className="tooltips">Configuración</div> : ""}
          </li>
          <hr />
          <li className="itemContent">
            <a id="edit-user" href="/pgi/usuarios">
              <PersonOutline /> <span>Usuario</span>
            </a>
            {!open ? <div className="tooltips">Usuario</div> : ""}
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default NavBarPgi;
